import {
    AfterContentInit,
    Component,
    ViewEncapsulation,
    ElementRef,
    Input,
    Output,
    EventEmitter,
    forwardRef
}                               from "@angular/core";
import {
    ControlValueAccessor,
    FormsModule,
    NG_VALUE_ACCESSOR  
}                               from "@angular/forms";
  
import { ResponseMessage }      from "../../models";
import { GlobalState } from "../../services";
  
export const CTM_TEXTBOX_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CtmTextbox),
    multi: true
};
  
@Component({
    selector: "ctm-textbox",
    template: require('./textbox.html'),
    providers: [CTM_TEXTBOX_CONTROL_VALUE_ACCESSOR],
    host: {   
    },
    encapsulation: ViewEncapsulation.None
})
export class CtmTextbox implements ControlValueAccessor {
    constructor(
        private _element: ElementRef,
        private state: GlobalState
    ) { 

    }
  
    private _value: any = "";
    private _readonly: boolean = false;
    private _disabled: boolean = false;
    private _error: ResponseMessage = new ResponseMessage();
    
    _onChange = (value: any) => { };
    _onTouched = () => { };
  
    @Input("type")
    textType: string = "text";
  
    @Input()
    tabindex: number = 0;
    @Input() 
    placeholder: string = "";
    @Input("prefix")
    prefix: string = null;
    @Input("minlength") 
    minLength: number = 0;
    @Input("maxlength")
    maxLength: number = 100;
    @Input("tab-with-enter")
    tabWithEnter: boolean = false;
  
    @Input()
    get readonly(): boolean { 
        return this._readonly; 
    }
    set readonly(value) { 
        this._readonly = value; 
    }
  
    @Input()
    get disabled(): boolean { 
        //return this._disabled; 
        return this._readonly;
    }
    set disabled(value) { 
        //this._disabled = value; 
        this._readonly = value;
    }
  
    @Input()
    get error(): ResponseMessage { 
        return this._error; 
    }
    set error(value) {
        if (value != undefined) {
            if (typeof(value) == "string") {
                this._error = new ResponseMessage();
                this._error.type = "error";
                this._error.message = value;
            }
            else {
                this._error = value;
            } 
        }
    }
  
    @Input()
    get value(): any { return this._value; }
    set value(value: any)  {
        this._value = value;
        
        this._onChange(value);
        // this.change.emit({
        //   source: this,
        //   value: value
        // });
    }
  
    //@Output() change: EventEmitter<any> = new EventEmitter<any>();
    @Output() focus: EventEmitter<any> = new EventEmitter<any>();
    @Output() blur: EventEmitter<any> = new EventEmitter<any>();
    @Output() keypress: EventEmitter<any> = new EventEmitter<any>();

    writeValue(value: any): void {
        if (value !== this._value) {
            this._value = value;
        }
    }
  
    registerOnChange(fn: (value: any) => void): void { this._onChange = fn; }
  
    registerOnTouched(fn: () => {}): void { this._onTouched = fn; }
  
    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
  
    private onKeypress(event) {
        if (event.keyCode == 13) {
            if (this.tabWithEnter) {
                let ctrls = $("main").find("input, button");
                let cidx = ctrls.index($(event.target));
                let idx = cidx + 1;
                if (idx >= 0) {
                    while(cidx != idx) {
                        if (idx >= ctrls.length) {
                            idx = 0;
                        }
                        
                        if ($(ctrls[idx]).attr("disabled")) {
                            idx++;
                        }
                        else {
                            $(ctrls[idx]).focus();
                            break;
                        }
                    }
                }

                return false;
            }      
        }

        this.keypress.emit(event);
    }
    private onChange() {
        this._error.type = null;
        this._error.message = null;
    }
    private onFocus() {
        if (this._disabled == false
            && this._readonly == false) {

            // setTimeout(()=> {
            //     this._element.nativeElement.querySelector('input').select();
            //     this.focus.emit();
            // }, 0);
            this.state.setFocus(() => {
                this._element.nativeElement.querySelector('input').select();
                this.focus.emit();
            });
        }
    }
    private onBlur() {
        this._onTouched();
        this.blur.emit();
    } 
  
    public setFocus() {
        this.state.setFocus(() => {
            this._element.nativeElement.querySelector('input').focus();
        });
    }
    public setSelect() {
        this.state.setFocus(() => {
            this._element.nativeElement.querySelector('input').select();
        });
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/components/textbox/textbox.ts